/*
 * @Author: mkRui 1102163949@qq.com
 * @Date: 2025-10-12 16:20:40
 * @LastEditors: mkRui 1102163949@qq.com
 * @LastEditTime: 2025-10-12 19:28:36
 * @FilePath: /polordar-explorer/ui/snippets/topBar/settings/SettingsLanguage.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Box, createListCollection, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { useAppContext } from 'lib/contexts/app';
import * as cookies from 'lib/cookies';
import { useTranslation } from 'lib/i18n/LanguageContext';
import type { SelectOption } from 'toolkit/chakra/select';
import PopoverFilterRadio from 'ui/shared/filters/PopoverFilterRadio';
import IconSvg from 'ui/shared/IconSvg';

type LangOption = 'en' | 'zh';

const OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'zh', label: '简体中文' },
] as Array<{ value: LangOption; label: string }>;

const collection = createListCollection<SelectOption>({ items: OPTIONS });

const SettingsLanguage = () => {
  const { t, lang, setLang } = useTranslation();
  const { cookies: appCookies } = useAppContext();

  const initialCookie = (cookies.get(cookies.NAMES.LANGUAGE, appCookies) as LangOption) || 'en';
  const [ value, setValue ] = React.useState<LangOption>(lang || initialCookie);

  const onChange = React.useCallback((next: string | Array<string>) => {
    if (Array.isArray(next)) return;
    const val = (next as LangOption);
    setValue(val);
    setLang(val);
  }, [ setLang ]);

  return (
    <>
      <Box borderColor="divider" borderTopWidth="1px" my={ 3 }/>
      <Box fontWeight={ 600 }>{ t('settings.language') }</Box>
      <Box color="text.secondary" mt={ 1 } mb={ 2 }>
        { value === 'zh' ? t('settings.language.zh') : t('settings.language.en') }
      </Box>
      <Flex gap="4">
        <IconSvg
          name="local/en"
          boxSize={ 6 }
          onClick={ () => onChange('en') }
          cursor="pointer"
        />
        <IconSvg
          name="local/zh"
          boxSize={ 6 }
          onClick={ () => onChange('zh') }
          cursor="pointer"
        />
      </Flex>
    </>
  );
};

export default React.memo(SettingsLanguage);
